import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  IconConfig,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { UiModule } from 'src/app/ui/ui.module';

/** One "label → link" row of the alert Related section (EVENT, SPACE). */
@Component({
  selector: 'app-related-link-row',
  templateUrl: './related-link-row.component.html',
  styleUrls: ['./related-link-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, UiModule, PencilIconComponent],
})
export class RelatedLinkRowComponent {
  /** Already-translated row label; see RelatedUserRowComponent.label for why. */
  @Input() label = '';
  @Input() iconConfig?: IconConfig;
  @Input() text = '';
  @Input() url = '';
  /** `data-name` for the link, so tests can tell the rows apart. */
  @Input() dataName = '';
}
